export default {
  getBankStatements: (state) => state.bankStatements,
  getBankStatement: (state) => (id) => {
    return state.bankStatements.find(bankStatement => bankStatement.id === parseInt(id))
  },
  getEmptyBankStatement: (state) => JSON.parse(JSON.stringify(state.emptyBankStatement)),
}